export class GastoDetalle {
    public constructor(
        public id: String = "",
        public cantidad: number = 0,
        public descripcion: String = "",
        public precio_unitario: number = 0,
        // public es_servicio: boolean = false,
        public tipo_producto_id: string = "",
        public desc_valor: number = 0,
        public graba_iva: boolean =false,
        public bandera_credito_tributario: boolean = false,
        public credito_tributario: String ="",
        //public desc_porcent: number = 0,

    
        public subtotal: number = 0,
        public iva:number = 0,
        public total: number = 0,
        public compra_id: String = "",
        public producto_id: String = "", 
        public empresa_id: String = "",
        public sucursal_id: String = "",
        public usuario_id:String = null
    ){}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/gasto-detalle.ts